import { apiClient } from "lib/apiClient";
import { ICompanyGroup } from "./getCompanyGroups";

export const getChildCompanies = async (
  companyId: string,
  status: string
): Promise<ICompanyGroup[]> => {
  const response = await apiClient.get(
    `/companies/${companyId}/children?status=${status}`
  );

  return response.data;
};
